import Box from '@mui/material/Box'
import CustomMapMarkerIcon from '../../Icons/js/CustomMapMarker'
import { ITooltip } from '../../index'

const CustomMapMarkerButton = ({ isOpen, className, onClick }) => (
  <Box
    className={className}
    onClick={onClick}
    sx={(theme) => ({
      alignItems: 'center',
      background: theme.palette.quaternary.main,
      border: isOpen
        ? `2px solid ${theme.palette.secondary.accent}`
        : `0px solid ${theme.palette.secondary.accent}`,
      borderRadius: 1,
      boxShadow: '0px 3px 6px #00000029',
      cursor: 'pointer',
      display: 'flex',
      height: 35,
      justifyContent: 'center',
      marginRight: '13px',
      minHeight: 35,
      minWidth: 35,
      transition: 'border .05s',
      width: 35,
      '&:hover': { border: `2px solid ${theme.palette.secondary.accent}` },
      '& svg': {
        fill: isOpen ? theme.palette.primary.accent : theme.palette.primary.main,
        stroke: isOpen ? theme.palette.primary.accent : theme.palette.primary.main,
        transition: 'fill .25s, stroke .25s'
      }
    })}
  >
    <ITooltip content='Customize markers' placement='top'>
      <CustomMapMarkerIcon />
    </ITooltip>
  </Box>
)

export default CustomMapMarkerButton
